import * as React from "react";
import {none, option} from "ts-option";
import SelectedAddressPresenter from "./SelectedAddressPresenter";
import AddressSelectionComponent from "./AddressSelectionComponent";
import Address from "../../../model/address/Address";
import {FocusableProps} from "../../common/props/FocusableProps";
import {ValuableProps} from "../../common/props/ValuableProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";

type Props = ValuableProps<Address> & FocusableProps & PlaceholderProps

export default class SelectAddress extends React.PureComponent<Props, {}> {
	refs: {
		AddressSelectionComponent: AddressSelectionComponent
	};

	render() {
		return (
			<div>
				{
					this.props.value.map(address => {
						return (
							<SelectedAddressPresenter address={address}
													  onReset={() => this.resetSelectedAddress()}
													  onFocus={this.props.onFocus}
													  focus={this.props.focus}
													  onClick={() => this.props.onChange(none)}/>
						)

					}).orNull
				}
				<AddressSelectionComponent ref={"AddressSelectionComponent"}
										   onSelect={address => this.props.onChange(option(address))}
										   visible={this.props.value.isEmpty}
										   onFocus={this.props.onFocus}
										   focus={this.props.focus}
										   placeholder={this.props.placeholder}
										   initialSearchQuery={undefined}/>
			</div>
		)
	}

	/**
	 * Reset selected address and clears the input field.
	 */
	resetSelectedAddress() {
		this.props.onChange(none);
		if (this.refs.AddressSelectionComponent)
			this.refs.AddressSelectionComponent.resetSearchInput();
	}
}

